import ServicesPage from '@/pages/ServicesPage/ServicesPage';

export default ServicesPage;
